import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface ChevronIconProps {
    direction?: 'up' | 'down' | 'left' | 'right';
    color?: string;
    className?: string;
}

function ChevronIcon({
    direction = 'down',
    color = 'currentColor',
    className = null,
}: ChevronIconProps) {
    let transform = null;
    if (direction === 'up') {
        transform = 'scaleY(-1)';
    } else if (direction === 'right') {
        transform = null;
    } else if (direction === 'left') {
        transform = 'rotate(180deg)';
    }
    if (direction === 'right' || direction === 'left') {
        return (
            <svg
                className={classNames([styles.container, className])}
                width="9"
                height="15"
                viewBox="0 0 9 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    style={{
                        transform,
                        transformOrigin: 'center',
                        transition: '0.1s transform ease',
                    }}
                >
                    <path
                        d="M1.15091 14.4197C1.22047 14.4894 1.30309 14.5446 1.39403 14.5823C1.48497 14.6201 1.58246 14.6395 1.68091 14.6395C1.77936 14.6395 1.87684 14.6201 1.96778 14.5823C2.05873 14.5446 2.14134 14.4894 2.21091 14.4197L8.46091 8.16971C8.53057 8.10015 8.58584 8.01753 8.62354 7.92659C8.66125 7.83564 8.68066 7.73816 8.68066 7.63971C8.68066 7.54126 8.66125 7.44378 8.62354 7.35283C8.58584 7.26189 8.53057 7.17928 8.46091 7.10971L2.21091 0.859711C2.1413 0.79011 2.05868 0.7349 1.96774 0.697233C1.8768 0.659566 1.77934 0.640179 1.68091 0.640179C1.58248 0.640179 1.48501 0.659566 1.39407 0.697233C1.30313 0.7349 1.22051 0.79011 1.15091 0.859711C1.08131 0.929312 1.0261 1.01194 0.988428 1.10288C0.95076 1.19381 0.931372 1.29128 0.931372 1.38971C0.931372 1.48814 0.95076 1.58561 0.988428 1.67655C1.0261 1.76748 1.08131 1.85011 1.15091 1.91971L6.86991 7.63971L1.15091 13.3597C1.08124 13.4293 1.02598 13.5119 0.988268 13.6028C0.95056 13.6938 0.931152 13.7913 0.931152 13.8897C0.931152 13.9882 0.95056 14.0856 0.988268 14.1766C1.02598 14.2675 1.08124 14.3501 1.15091 14.4197Z"
                        fill={color}
                    />
                </g>
            </svg>
        );
    }
    return (
        <svg
            className={classNames([styles.container, className])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={24.11}
            height={14.33}
            viewBox="0 0 24.11 14.33"
        >
            <g
                style={{
                    transform,
                    transformOrigin: 'center',
                    transition: '0.1s transform ease',
                }}
            >
                <path
                    fill="none"
                    stroke={color}
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M22.32,1.71L11.61,12.57L1.72,1.71"
                />
            </g>
        </svg>
    );
}

export default ChevronIcon;
